import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type Step = 'process' | 'upload' | 'analyze';
export type LoadingProps = {
  step: Step;
  showSlowConnectionMessage?: boolean;
};
const Loading = t0 => {
  const $0 = _c(18);
  const {
    step,
    showSlowConnectionMessage
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.loading"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($0[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LoadingSpinner size="xlarge" />;
    $0[1] = t2;
  } else {
    t2 = $0[1];
  }
  let t3;
  if ($0[2] !== step) {
    t3 = $ => $.title[step];
    $0[2] = step;
    $0[3] = t3;
  } else {
    t3 = $0[3];
  }
  let t4;
  if ($0[4] !== t || $0[5] !== t3) {
    t4 = t(t3);
    $0[4] = t;
    $0[5] = t3;
    $0[6] = t4;
  } else {
    t4 = $0[6];
  }
  let t5;
  if ($0[7] !== t4) {
    t5 = <div className="text-label-1 mt-4 text-center text-primary">{t4}</div>;
    $0[7] = t4;
    $0[8] = t5;
  } else {
    t5 = $0[8];
  }
  const t6 = `text-body-2 text-center ${showSlowConnectionMessage ? "text-error" : "text-secondary"}`;
  let t7;
  if ($0[9] !== showSlowConnectionMessage || $0[10] !== t) {
    t7 = showSlowConnectionMessage ? t(_temp) : t(_temp2);
    $0[9] = showSlowConnectionMessage;
    $0[10] = t;
    $0[11] = t7;
  } else {
    t7 = $0[11];
  }
  let t8;
  if ($0[12] !== t6 || $0[13] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $0[12] = t6;
    $0[13] = t7;
    $0[14] = t8;
  } else {
    t8 = $0[14];
  }
  let t9;
  if ($0[15] !== t5 || $0[16] !== t8) {
    t9 = <div className="flex flex-col items-center p-6">{t2}<div className="flex flex-col justify-center items-center gap-2">{t5}{t8}</div></div>;
    $0[15] = t5;
    $0[16] = t8;
    $0[17] = t9;
  } else {
    t9 = $0[17];
  }
  return t9;
};
export default Loading;
function _temp($_0) {
  return $_0["slow-connection"];
}
function _temp2($_1) {
  return $_1.subtitle;
}